module.exports = __webpack_public_path__ + "media/images/category/dummy/outer02-87f2d21568897f4d8f6fae54dd5f0b74.jpg";